<template>
  <v-card class="pa-2 mt-3" outlined flat>
    <v-form>
      <v-container>
        <v-row>
          <v-col cols="12" md="4">
            <v-text-field v-model="items.individualName" label="Individual Served Name"
              :outlined="outlined"></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field v-model="items.caseNo" label="Case #" :outlined="outlined"></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field v-model="items.monthYear" label="Month/Year" :outlined="outlined"></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field v-model="items.provider" label="Provider" :outlined="outlined"></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-radio-group v-model="items.rbgUrban" row>
              <v-radio label="Urban" :value="true"></v-radio>
              <v-radio label="Rural" :value="false"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field v-model="items.individualSignature" label="Individual Signature:"
              :outlined="outlined"></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-row>
              <v-checkbox v-model="items.chkPcp" label="PCP identifies individual unable to sign
due to physical and/or cognitive disability" value="true"></v-checkbox>
            </v-row>
          </v-col>
          <v-col cols="6">
            <v-text-field v-model="items.staffName" label="Staff Printed Name" :outlined="outlined"></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field v-model="items.staffSignature" label="Staff Signature" :outlined="outlined"></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" class="white--text text-uppercase text-center text-caption"
            style="background-color: #2b3990">Please write legibly. One day per line. Entries must be in date
            order and not prefilled.
          </v-col>
          <v-col cols="12">
            <v-sheet elevation="1" class="pa-5">
              <table>
                <thead>
                  <tr>
                    <td>
                      <div class="text-center text-body-2 font-weight-bold">
                        Date <br />
                        XX/XX/20XX
                      </div>
                    </td>
                    <td>
                      <div class="text-center text-body-2 font-weight-bold">
                        Start Time <br />
                        00:00 <br />
                        AM/PM
                      </div>
                    </td>
                    <td>
                      <div class="text-center text-body-2 font-weight-bold">
                        End Time <br />
                        00:00 <br />
                        AM/PM
                      </div>
                    </td>
                    <td>
                      <div class="text-center text-body-2 font-weight-bold">
                        Total Hours <br />
                        <span class="caption">Round to the nearest ¼ hour (.25)</span>
                        <br />
                      </div>
                    </td>
                    <td>
                      <div class="text-center text-body-2 font-weight-bold">
                        Ind. Initial
                      </div>
                    </td>
                    <td>
                      <div class="text-center text-body-2 font-weight-bold">
                        Staff Initial
                      </div>
                    </td>
                    <td v-if="items.timesheets.length > 1">
                      <div class="text-center text-body-2 font-weight-bold">
                        Action
                      </div>
                    </td>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="(timesheet, i) in items.timesheets" :key="i">
                    <td class="text-center">
                      <div class="pa-2">
                        <v-text-field v-model="timesheet.date" :outlined="outlined" dense hide-details></v-text-field>
                      </div>
                    </td>
                    <td class="text-center">
                      <div class="pa-2">
                        <v-text-field v-model="timesheet.start" :outlined="outlined" dense hide-details></v-text-field>
                      </div>
                    </td>
                    <td class="text-center">
                      <div class="pa-2">
                        <v-text-field v-model="timesheet.end" :outlined="outlined" dense hide-details></v-text-field>
                      </div>
                    </td>
                    <td class="text-center">
                      <div class="pa-2">
                        <v-text-field v-model="timesheet.totalHours" :outlined="outlined" dense
                          hide-details></v-text-field>
                      </div>
                    </td>

                    <td class="text-center">
                      <div class="pa-2">
                        <v-text-field v-model="timesheet.indInitial" :outlined="outlined" dense
                          hide-details></v-text-field>
                      </div>
                    </td>

                    <td class="text-center">
                      <div class="pa-2">
                        <v-text-field v-model="timesheet.staffInitial" :outlined="outlined" dense
                          hide-details></v-text-field>
                      </div>
                    </td>

                    <td v-if="items.timesheets.length > 1" class="text-center">
                      <div class="pa-2">
                        <v-btn color="error" dark right class="" @click="removeTimesheet(i)">
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>

              <div class="d-flex justify-end mt-5">
                <v-btn color="warning" dark right class="" @click="clearItems">
                  clear
                </v-btn>
                <div class="ma-1"></div>
                <v-btn color="primary" dark right class="" @click="addTimesheet">
                  add
                </v-btn>
              </div>
            </v-sheet>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </v-card>
</template>
<script>
/*eslint-disable */
export default {
  props: {
    items: Object
  },
  data() {
    return {
      outlined: true,
      // items: {
      //   timesheets: [{}],
      // },
    };
  },
  methods: {

    getItems(){
      console.log(this.items)
      return this.items
    },
    
    getData() {
      return this.flattenArrays({
        ...this.items,
        ...this.timesheetCalculatedHours(),
      });
    },

    addTimesheet() {
      this.items.timesheets.push({});
    },

    removeTimesheet(i) {
      this.items.timesheets.splice(i, 1);
    },

    clearItems() {
      this.items.timesheets = [{}];
    },

    flattenArrays(data) {
      const flattened = {};
      Object.entries(data).forEach(([key, value]) => {
        if (!Array.isArray(value)) {
          flattened[key] = value;
        } else {
          value.forEach((item, index) => {
            Object.entries(item).forEach(([innerKey, innerValue]) => {
              flattened[`${innerKey}${index + 1}`] = innerValue;
            });
          });
        }
      });

      return flattened;
    },

    timesheetCalculatedHours() {
      const timesheetLength = this.items.timesheets.length;
      const pageBreaks = [0, 19, 38, 57, 76];

      const totals = {
        page1TotalHours1: this.timesheetsPage(pageBreaks, timesheetLength)[0],
        page1TotalHours2: this.timesheetsPage(pageBreaks, timesheetLength)[1],
        page2TotalHours1: this.timesheetsPage(pageBreaks, timesheetLength)[2],
        page2TotalHours2: this.timesheetsPage(pageBreaks, timesheetLength)[3],
      };

      totals.page1OverallTotal =
        totals.page1TotalHours1 + totals.page1TotalHours2;
      totals.currentPageTotalHours =
        totals.page2TotalHours1 + totals.page2TotalHours2;
      totals.previousPageTotalHours = totals.page1OverallTotal;
      totals.totalMonthHours =
        totals.currentPageTotalHours + totals.previousPageTotalHours;

      Object.keys(totals).forEach((key) => {
        totals[key] = totals[key].toString();
      });

      return totals
    },

    timesheetsPage(pageBreaks, timesheetLength) {
      return pageBreaks.map((breakPoint, index, array) =>
        index < array.length - 1
          ? this.calculateTotalHours(
            breakPoint,
            Math.min(array[index + 1], timesheetLength)
          )
          : 0
      );
    },

    calculateTotalHours(startIndex, limit) {
      return this.items.timesheets
        .slice(startIndex, limit)
        .reduce((total, timesheet) => {
          const hours = parseInt(timesheet.totalHours, 10);
          return total + (isNaN(hours) ? 0 : hours);
        }, 0);
    },
  },
};
</script>

<style scoped>
h1 {
  font-size: 1.5rem;
  font-weight: 400;
}

.fab--btn {
  display: "absolute";
  bottom: 10px;
}

.fab--btn.delete {
  right: calc(-100% + 20px);
}

.fab--btn.delete.custome {
  right: calc(-100% + -10px);
  top: 40px;
}

/* table design */
table {
  border-collapse: collapse !important;
}

table,
th,
td {
  border: 1px solid;
}

table {
  width: 100%;
}

.chk {
  /* background-color: red; */
  justify-content: center;
  margin: -10px;
}
</style>
